import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}salesleads/${COMMON_QUERY_PARAMS.ID}/onboardingstatus`;

export enum ONBOARDING_PROVISIONING_STATE {
  NOT_STARTED = 'NotStarted',
  IN_PROGRESS = 'InProgress',
  FAILED = 'Failed',
  READY = 'Ready',
}

export enum ONBOARDING_PROVISIONING_STEP {
  SELLER_CONTEXT = 'SellerContext',
  TEMPLATE_DUPLICATION = 'TemplateDuplication',
  DEMO_ORDERS = 'DemoOrders',
  DEMO_FILES = 'DemoFiles',
}

export interface Onboardingstatus {
  provisioningState: ONBOARDING_PROVISIONING_STATE;
  provisioningStep?: ONBOARDING_PROVISIONING_STEP;
  demoContextPersonalized: boolean;
  emailConfirmed: boolean;
  demoContextInfrastructureBuilt: boolean;
  demoContextEntitiesAndRulesDuplicated: boolean;
  demoContextDemoOrdersGenerated: boolean;
  demoContextFullyProvisionned: boolean;
  registered: boolean;
  invitationId: string;
  email: string;
}

interface GetSalesLeadOnboardingStatusQueryArgs {
  id: string;
}

const getSalesLeadOnboardingStatusQuery = async ({
  id,
}: GetSalesLeadOnboardingStatusQueryArgs): Promise<
  BackResponse<Onboardingstatus> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.ID, id);

    const response = await apiCall<BackResponse<Onboardingstatus>>(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getSalesLeadOnboardingStatusQuery;
